export const CLIENT_GROUPS = [
  { key: "recorrentes", nome: "Recorrentes", vazio: "Nenhum cliente recorrente." },
  { key: "one_time", nome: "One time", vazio: "Nenhum cliente one time." },
  { key: "onboarding", nome: "Onboarding", vazio: "Nenhum cliente em onboarding." },
  { key: "encerrados", nome: "Encerrados", vazio: "Nenhum cliente encerrado." },
];

export const grupoDoCliente = (cliente) => {
  if (cliente.status === "encerrado") return "encerrados";
  if (cliente.status === "onboarding") return "onboarding";
  return cliente.tipo === "recorrente" ? "recorrentes" : "one_time";
};

export const tipoCliente = (cliente) => cliente.tipo === "recorrente"
  ? `Recorrente${cliente.frequencia_captacao ? ` · captação ${cliente.frequencia_captacao}` : ""}`
  : "One time";
